import React, { useState } from "react";
import SitePage from "../SitePage";
import { Plus, Minus, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

const FAQS = [
  {
    q: "Come funziona la Daita'n'Card?",
    a: "È la nostra fidelity card gratuita e digitale. Ti dà prezzi Club, prelazione di 48 ore sui nuovi arrivi, punti a ogni acquisto (1€ = 1 punto, buono da 50€ a 500 punti) e un codice cliente univoco inviato via email subito dopo l'attivazione. La richiedi dal form in Home.",
    link: { to: "/drop-club", label: "Scopri il Drop Club" },
  },
  {
    q: "Vendete pezzi originali? Come li riconoscete?",
    a: "Sì, esclusivamente. Compriamo solo da distributori ufficiali con licenza attiva. Se un editore ci nega la fornitura, il prodotto non entra in bottega. Cloni, KO e bootleg non li trattiamo per policy.",
    link: { to: "/autenticita", label: "Leggi la garanzia autenticità" },
  },
  {
    q: "Le foto dei prodotti sono reali o rendering?",
    a: "Le facciamo noi nel retro-bottega, dopo il quality check. Sono le stesse che vedi nel Lookbook. Su qualche edizione da preordine può esserci un render del produttore, ma è sempre indicato nella scheda.",
    link: { to: "/lookbook", label: "Vai al Lookbook" },
  },
  {
    q: "Quanto ci mette ad arrivarmi?",
    a: "In Italia in genere 2-4 giorni lavorativi dopo la spedizione. Nel resto d'Europa 5-9 giorni. Le tariffe definitive stanno per essere pubblicate — scrivici in chat per un preventivo sul tuo ordine specifico.",
    link: { to: "/spedizioni", label: "Vedi come spediamo" },
  },
  {
    q: "Posso rimandare indietro un pezzo se ci ripenso?",
    a: "Sì, hai 14 giorni di diritto di recesso pieno dalla ricezione. Il pezzo deve essere integro, nella confezione originale sigillata. Le spese di ritorno sono a carico tuo, tranne che per prodotti difettosi.",
    link: { to: "/resi", label: "Leggi la policy resi" },
  },
  {
    q: "Posso pagare in contanti in negozio?",
    a: "Certo. Se preferisci ritirare in bottega, seleziona &quot;Ritiro in negozio&quot; al checkout e paghi quando vieni. Siamo in Via Michele Coppino 88, Viareggio.",
  },
  {
    q: "Le edizioni limitate sono davvero limitate?",
    a: "Sì, e vendute con numero di serie dichiarato. Se un pezzo è 234/500, sull'etichetta trovi proprio quello. Se il produttore non certifica il numero, non lo etichettiamo come &quot;limitato&quot;.",
  },
  {
    q: "Fate preordini?",
    a: "Solo su pezzi con data d'uscita ufficiale del produttore. Preordine = caparra del 20-30%, saldo al momento della spedizione. Se il produttore ritarda o cancella, rimborso pieno immediato.",
  },
  {
    q: "Come vi contatto?",
    a: "Il modo più veloce è la chat: c'è Daita-chan h24 e se serve un umano ti mette in coda. Altrimenti daitanjackreloaded@gmail.com o passa in negozio a Viareggio.",
    link: { to: "/contatti", label: "Tutti i contatti" },
  },
  {
    q: "Fate sconti per collezionisti fedeli?",
    a: "I punti della Daita'n'Card si accumulano da soli e diventano buoni. Oltre a quello, il prezzo Club è sempre il migliore che possiamo fare senza svendere il pezzo — non aspettare Black Friday.",
  },
];

const FaqItem = ({ item, open, onToggle, idx }) => (
  <div data-testid={`faq-item-${idx}`} className="border-b border-zinc-800">
    <button
      onClick={onToggle}
      data-testid={`faq-toggle-${idx}`}
      className="w-full flex items-center justify-between gap-4 py-5 text-left group"
      aria-expanded={open}
    >
      <span className="font-heading uppercase text-white group-hover:text-yellow-400 transition text-base sm:text-lg tracking-wide">
        {item.q}
      </span>
      <span className="bg-zinc-900 border-2 border-zinc-800 group-hover:border-yellow-400 p-1.5 shrink-0 transition">
        {open ? <Minus className="w-4 h-4 text-yellow-400" strokeWidth={3} /> : <Plus className="w-4 h-4 text-yellow-400" strokeWidth={3} />}
      </span>
    </button>
    {open && (
      <div data-testid={`faq-answer-${idx}`} className="pb-6 text-zinc-400 text-sm leading-relaxed">
        <p dangerouslySetInnerHTML={{ __html: item.a }} />
        {item.link && (
          <Link to={item.link.to} className="mt-3 inline-block text-yellow-400 hover:text-white text-xs uppercase tracking-widest font-heading transition">
            → {item.link.label}
          </Link>
        )}
      </div>
    )}
  </div>
);

export default function FaqPage() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <SitePage
      testId="faq-page"
      breadcrumb="Help"
      breadcrumbLabel="FAQ"
      eyebrow="FAQ / よくある質問"
      title="Domande"
      accent="frequenti"
      subtitle="Le cose che ci chiedono più spesso — clienti nuovi, collezionisti seri e curiosi di passaggio. Se qui non trovi la tua risposta, apri la chat e ti rispondiamo in giornata."
    >
      <div data-testid="faq-list">
        {FAQS.map((item, i) => (
          <FaqItem key={i} idx={i} item={item} open={openIdx === i} onToggle={() => setOpenIdx(openIdx === i ? -1 : i)} />
        ))}
      </div>

      <div className="mt-12 text-center border-t-2 border-zinc-800 pt-10">
        <p className="text-zinc-500 italic mb-6 max-w-lg mx-auto">
          Non c&apos;è la tua domanda? Nessun problema, ci pensiamo noi.
        </p>
        <button data-testid="faq-cta-chat" onClick={openChat} className="skew-btn bg-yellow-400 text-black font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-black hover:text-yellow-400 transition inline-flex items-center gap-2">
          <MessageCircle className="w-4 h-4" strokeWidth={3} /> <span>Chiedici in chat</span>
        </button>
      </div>
    </SitePage>
  );
}
